var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import deleteAssetLabel from '../../requests/label/deleteAssetLabel';
/**
 *
 */
var DeleteAssetLabelCommand = /** @class */ (function (_super) {
    __extends(DeleteAssetLabelCommand, _super);
    function DeleteAssetLabelCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param labelId string
     * @param assetId string
     * @param organisationId string
     * @return {*}
     */
    DeleteAssetLabelCommand.prototype.execute = function (labelId, assetId, organisationId) {
        var promise = deleteAssetLabel(labelId, assetId, organisationId);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    DeleteAssetLabelCommand.prototype.then = function (response) {
    };
    return DeleteAssetLabelCommand;
}(Command));
export default DeleteAssetLabelCommand;
